export const EMAIL_PATTERN =
    "^[A-Za-z0-9._%-+]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$";

export const isEmpty = (value) => {
    return (
        !value ||
        value === null ||
        (typeof value === "string" && value.trim() === "")
    );
};

export const isValueValid = (value, regExp) => {
    const reg = new RegExp(regExp);
    return reg.test(value);
};

export const isValidEmail = (email) => {
    return isValueValid(email, EMAIL_PATTERN);
};

export const isLessThanMinLength = (value, length) => {
    return value.length < length;
};

export const isGreaterThanMaxLength = (value, length) => {
    return value.length > length;
};

export const getSanitizedString = (originalString) => {
    if (originalString) {
        return originalString.split(" ").join("");
    }
    return undefined;
}
